// Daggerheart SRD 1.0 — Darrington Press Community Gaming License
// © 2025 Critical Role LLC — https://www.darringtonpress.com/license

export const DH_CONDITIONS = [
  { id: 'restrained',  name: 'Restrained',  icon: '⛓',  desc: 'You cannot move from your current position.' },
  { id: 'vulnerable',  name: 'Vulnerable',  icon: '💢',  desc: 'Attacks against you deal +1d4 damage.' },
  { id: 'hidden',      name: 'Hidden',      icon: '👻',  desc: 'You cannot be targeted by attacks until you act or are revealed.' },
  { id: 'slow',        name: 'Slow',        icon: '🐌',  desc: 'You cannot take a reaction this round.' },
  { id: 'frightened',  name: 'Frightened',  icon: '😨',  desc: 'You must move away from the source of your fear when possible.' },
  { id: 'unconscious', name: 'Unconscious', icon: '💤',  desc: 'You are incapacitated and cannot take actions.' },
];
